import React from "react";
import videojs from "video.js";
import { cdnUrlBase } from "../constants/config";

function getWidth() {
  return (
    document.documentElement.clientWidth ||
    window.innerWidth ||
    document.body.clientWidth
  );
}

function shouldAutoplay(){
  return getWidth() > 750;
}

export default class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
  }
  componentDidMount() {
    const isAutoplaying = shouldAutoplay();
    const defaults = {
      controls: !isAutoplaying,
      autoplay: isAutoplaying,
      loop: true,
      preload: "auto",
      sources: [
        {
          src: `${cdnUrlBase}/${this.props.filePath}`,
          type: "video/mp4"
        }
      ]
    };
    this.player = videojs(this.videoRef.current, {
      ...defaults,
      ...this.props
    });
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render() {
    return (
      <div data-vjs-player>
        <video ref={this.videoRef} className="video-js vjs-fluid" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CDNVideo.js